'use client';
import { useEffect } from 'react';
 import HeroSection from'./components/HeroSection';
import ManifestoSection from './components/ManifestoSection';
 import VideoSection from'./components/VideoSection';
 import BenefitsSection from'./components/BenefitsSection';
 import ScarcitySection from'./components/ScarcitySection';
 import FinalCTASection from'./components/FinalCTASection';
 import Footer from'@/components/Footer';

export default function Homepage() {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal')
    if (!reveals?.length) return

    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    )
    reveals?.forEach(el => observer?.observe(el))

    return () => observer?.disconnect();
  }, [])

  return (
    <main className="custom-scrollbar selection:bg-primary selection:text-primary-foreground">
      {/* Grain Texture Overlay */}
      <div className="grain-overlay"></div>

      {/* Page Sections */}
      <HeroSection />
      <ManifestoSection />
      <VideoSection />
      <BenefitsSection />
      <ScarcitySection />
      <FinalCTASection />
      <Footer />
    </main>
  )
}